/**
 * 마커 이슈의 아이콘 표현 공용 토큰 — 2D `annotationStyleCache`·`FeaturesStore` 와 3D `buildAnnotationEntity` 가 같은 값을 읽는다.
 * 아이콘 하단이 좌표에 닿고(bottom anchor), 라벨은 아이콘 위에 놓인다.
 */
export const ANNOTATION_MARKER_STYLE = {
  icon: "/mapicon/marker-sharp.png",
  scale: 1.3,
  /** 좌표 기준 라벨 세로 오프셋(px, 위쪽이 음수) — 아이콘(20px × scale) 위에 라벨이 오도록 */
  labelOffsetYPx: -35,
} as const;
